import React, { useState, useCallback } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { InputField } from "../../../../Components/formElements/InputField";
import TableDropdownMenuModal from "../../../../Components/TableDropdownMenu/TableDropdownMenuModal";

const BarcodeSelectorMRCustomerV5 = ({
  lineItemId,
  materialCode,
  currentBarcode,
  equipmentItemNr = "",
  onFetchBarcodes,
  barcodeOptions = [],
  onAssign,
  onRemove,
  disabled = false,
  isAssigning = false,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedBarcode, setSelectedBarcode] = useState("");

  // Check if barcode is already assigned
  const isAssigned = Boolean(currentBarcode);

  /**
   * Handle dropdown click - fetch barcodes only when user clicks
   */
  const handleDropdownClick = useCallback(() => {
    if (disabled || isAssigned) return;

    // Fetch barcodes only if we don't have them yet
    if (!barcodeOptions || barcodeOptions.length === 0) {
      onFetchBarcodes(materialCode);
    }

    setShowModal(true);
  }, [disabled, isAssigned, barcodeOptions, onFetchBarcodes, materialCode]);

  /**
   * Handle barcode selection from modal
   * Manages internal state only - no parent notification needed
   */
  const handleBarcodeSelection = useCallback((data) => {
    if (data && data.value) {
      setSelectedBarcode(data.value);
    }
    setShowModal(false);
  }, []);

  /**
   * Handle assign button click
   */
  const handleAssign = useCallback(() => {
    if (selectedBarcode && !isAssigned) {
      onAssign(lineItemId, selectedBarcode, equipmentItemNr);
      // Clear selection after assignment attempt
      setSelectedBarcode("");
    }
  }, [lineItemId, selectedBarcode, isAssigned, onAssign, equipmentItemNr]);

  /**
   * Handle remove button click
   */

  //eslint-disable-next-line
  const handleRemove = useCallback(() => {
    if (isAssigned) {
      onRemove(lineItemId, currentBarcode, equipmentItemNr);
    }
  }, [lineItemId, currentBarcode, isAssigned, onRemove, equipmentItemNr]);

  // Prepare modal data
  const modalData = {
    index: lineItemId,
    name: "barcode",
    label: "Select Barcode",
    data: barcodeOptions,
    value: selectedBarcode,
    codeValue: selectedBarcode,
    descValue: selectedBarcode,
  };

  return (
    <div className="d-flex align-items-center gap-2 py-2">
      {/* Barcode Display/Selection Section */}
      <div style={{ flex: 1 }}>
        <Row>
          <Col xs={10} md={10} lg={10} className="commRightPadding">
            <InputField
              className="inputBox"
              label=""
              name="barcode"
              value={isAssigned ? currentBarcode : selectedBarcode}
              disabled={true}
              placeholder={isAssigned ? "Assigned" : "Select Barcode"}
            />
          </Col>
          <Col xs={2} md={2} lg={2}>
            <div
              style={{ width: "100%" }}
              className="d-flex justify-content-center iconTable"
            >
              <img
                src="assets/img/newIcons/drop-down.png"
                alt="select barcode"
                style={{
                  width: "20px",
                  height: "25px",
                  cursor: disabled || isAssigned ? "not-allowed" : "pointer",
                  opacity: disabled || isAssigned ? 0.5 : 1,
                }}
                className="mt-2"
                onClick={handleDropdownClick}
                title={
                  isAssigned
                    ? "Barcode already assigned"
                    : disabled
                      ? "Disabled"
                      : "Select Barcode"
                }
              />
            </div>
          </Col>
        </Row>
      </div>

      {/* Action Buttons Section */}
      {/* <div className="d-flex gap-2">
        {isAssigned ? (
          // Remove Button - shown when barcode is assigned
          <button
            className="btn btn-sm btn-danger"
            onClick={handleRemove}
            disabled={disabled || isAssigning}
            title="Remove assigned barcode"
          >
            {isAssigning ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-1"
                  role="status"
                  aria-hidden="true"
                ></span>
                Removing...
              </>
            ) : (
              <>
                <i className="bi bi-trash me-1"></i>
                Remove
              </>
            )}
          </button>
        ) : (
          // Assign Button - shown when no barcode is assigned
          <button
            className="btn btn-sm btn-primary"
            onClick={handleAssign}
            disabled={disabled || !selectedBarcode || isAssigning}
            title={
              !selectedBarcode
                ? "Please select a barcode first"
                : "Assign selected barcode"
            }
          >
            {isAssigning ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-1"
                  role="status"
                  aria-hidden="true"
                ></span>
                Assigning...
              </>
            ) : (
              <>
                <i className="bi bi-check-circle me-1"></i>
                Assign
              </>
            )}
          </button>
        )}
      </div> */}

      <div className="d-flex gap-2">
        {!isAssigned && (
          <button
            className="btn btn-sm btn-primary"
            onClick={handleAssign}
            disabled={disabled || !selectedBarcode || isAssigning}
            style={{ minWidth: "60px", padding: "2px 8px" }}
          >
            Assign
          </button>
        )}
      </div>

      {/* Modal for Barcode Selection */}
      <TableDropdownMenuModal
        show={showModal}
        onHide={() => setShowModal(false)}
        modaldata={modalData}
        onsuccess={handleBarcodeSelection}
      />
    </div>
  );
};

export default BarcodeSelectorMRCustomerV5;
